module.exports = __webpack_public_path__ + "img/imagotipo.93061450.png";